// extracted by mini-css-extract-plugin
export default {"chat-container":"Chat_chat-container__8usQb","sidebar-toggle-button":"Chat_sidebar-toggle-button__1Kqqk"};